<template>
    <sonicu-button  bg-color="bg-white"
                    bg-color-hover="!bg-blue-100"
                    text-color="text-blue-700"
                    text-color-hover="text-blue-700"
                    border-color="border-blue-300"
                    border-color-hover="border-transparent"
                    border-color-active="border-transparent"
                    @click="$emit('click', $event)"
    >
        <slot></slot>
    </sonicu-button>
</template>

<script>

import SonicuButton from "@/components/elements/buttons/SonicuButton";

export default {
    name: "ButtonBlueSecondary",
    mixins: [],
    emits: ['click'],
    components: {SonicuButton},
    props: {
        
    },
    data() {
        return {
            
        }
    },
    created() {
        
    },
    mounted() {
        
    },
    methods: {
        
    },
    computed: {
        
    },
    watch: {
        
    },
}
</script>

<style scoped>

</style>